import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  template: `
    <nav class="ds-nav" [class.is-scrolled]="scrolled">
      <div class="container ds-nav__inner">
        <a class="ds-nav__brand" routerLink="/" (click)="closeMenu()">
          <img src="assets/images/keyo-logo.jpeg" alt="Keyo AI" height="32">
        </a>

        <button
          class="ds-nav__toggler"
          [class.is-open]="menuOpen"
          type="button"
          (click)="toggleMenu()"
          [attr.aria-expanded]="menuOpen"
          aria-controls="navbarNav"
          aria-label="Menüyü aç/kapat"
        >
          <span></span><span></span><span></span>
        </button>

        <div class="ds-nav__menu" id="navbarNav" [class.show]="menuOpen">
          <ul class="ds-nav__list">
            <li>
              <a class="ds-nav__link" routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact: true}" (click)="closeMenu()">Ana Sayfa</a>
            </li>
            <li>
              <a class="ds-nav__link" routerLink="/how-it-works" routerLinkActive="is-active" (click)="closeMenu()">Nasıl Çalışır</a>
            </li>
            <li>
              <a class="ds-nav__link" routerLink="/packages" routerLinkActive="is-active" (click)="closeMenu()">Paketler</a>
            </li>
            <li>
              <a class="ds-nav__link" routerLink="/customers" routerLinkActive="is-active" (click)="closeMenu()">Müşteri Hikayeleri</a>
            </li>
            <li>
              <a class="ds-nav__link" routerLink="/about" routerLinkActive="is-active" (click)="closeMenu()">Hakkımızda</a>
            </li>
            <li>
              <a class="ds-nav__link" routerLink="/contact" routerLinkActive="is-active" (click)="closeMenu()">İletişim</a>
            </li>
          </ul>
          <a routerLink="/contact" fragment="contact-form" class="btn btn-primary ds-nav__cta" (click)="closeMenu()">Demo Talep Et</a>
        </div>
      </div>
    </nav>
  `,
  styles: [`
    .ds-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 100;
      height: 64px;
      background: rgba(255,255,255,0.85);
      transition: backdrop-filter var(--ds-motion-base),
                  background var(--ds-motion-base),
                  border-color var(--ds-motion-base),
                  box-shadow var(--ds-motion-base);
      border-bottom: 1px solid transparent;
    }
    .ds-nav.is-scrolled {
      background: rgba(255,255,255,0.85);
      backdrop-filter: saturate(180%) blur(8px);
      -webkit-backdrop-filter: saturate(180%) blur(8px);
      border-bottom-color: rgba(0,40,94,0.06);
    }
    .ds-nav__inner {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
    }
    .ds-nav__brand { display: flex; align-items: center; }
    .ds-nav__brand img { display: block; }

    .ds-nav__menu {
      display: flex;
      align-items: center;
      gap: 32px;
      flex: 1;
      justify-content: flex-end;
    }
    .ds-nav__list {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .ds-nav__link {
      display: inline-block;
      padding: 8px 14px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: var(--ds-text);
      text-decoration: none;
      border-radius: var(--ds-radius-button);
      transition: color var(--ds-motion-base), background var(--ds-motion-base);
    }
    .ds-nav__link:hover {
      color: var(--ds-text-display);
      background: var(--ds-bg-soft);
    }
    .ds-nav__link.is-active {
      color: var(--ds-text-display);
    }

    .ds-nav__cta {
      padding: 10px 18px;
      white-space: nowrap;
    }

    .ds-nav__toggler {
      display: none;
      background: transparent;
      border: none;
      width: 36px;
      height: 36px;
      flex-direction: column;
      justify-content: center;
      gap: 4px;
      cursor: pointer;
    }
    .ds-nav__toggler span {
      display: block;
      height: 2px;
      width: 22px;
      background: var(--ds-text-display);
      border-radius: 2px;
      transition: transform var(--ds-motion-base);
    }

    @media (max-width: 991.98px) {
      .ds-nav { height: 56px; }
      .ds-nav__toggler { display: flex; }

      .ds-nav__menu {
        display: none;
        position: absolute;
        top: 56px;
        left: 0;
        right: 0;
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        padding: 16px;
        background: #fff;
        border-bottom: 1px solid var(--ds-border);
        box-shadow: var(--ds-shadow-card);
      }
      .ds-nav__menu.show {
        display: flex;
      }
      .ds-nav__list {
        flex-direction: column;
        align-items: stretch;
        gap: 0;
      }
      .ds-nav__link {
        padding: 12px 14px;
      }
      .ds-nav__cta {
        margin-top: 8px;
        text-align: center;
        justify-content: center;
      }
    }
  `]
})
export class NavbarComponent implements OnInit, OnDestroy {
  scrolled = false;
  menuOpen = false;
  private routerSub?: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.closeMenu());
  }

  ngOnDestroy() {
    this.routerSub?.unsubscribe();
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu() {
    this.menuOpen = false;
  }

  @HostListener('window:scroll')
  onScroll() {
    this.scrolled = window.scrollY > 8;
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 992) {
      this.closeMenu();
    }
  }
}
